<template>
  <div class="advice-page">
    <div class="toolbar">
      <el-date-picker
        v-model="filterDate"
        type="date"
        placeholder="起始日期"
        format="YYYY-MM-DD"
        value-format="YYYYMMDD"
        style="width: 160px"
        @change="loadList"
      />
      <el-select v-model="strategy" placeholder="策略" clearable style="width: 160px" @change="loadList">
        <el-option v-for="opt in strategyOptions" :key="opt.value" :label="opt.label" :value="opt.value" />
      </el-select>
      <el-select v-model="filterStatuses" multiple placeholder="状态" clearable style="width: 160px" @change="loadList">
        <el-option label="未结算" :value="0" />
        <el-option label="已结算" :value="1" />
      </el-select>
      <el-button type="primary" @click="loadList">搜索</el-button>
    </div>

    <el-table
      ref="tableRef"
      :data="list"
      stripe
      style="width:100%"
      @selection-change="selChange"
    >
      <el-table-column type="selection" width="50" />
      <el-table-column prop="id" label="ID" width="80" />
      <el-table-column prop="date" label="日期" width="110" />
      <el-table-column prop="code" label="代码" width="100" />
      <el-table-column prop="name" label="名称" width="140" />
      <el-table-column prop="recommended_price" label="推荐价" width="120">
        <template #default="{row}">
          <span v-if="row.recommended_price != null">{{ Number(row.recommended_price).toFixed(2) }}</span>
          <span v-else>—</span>
        </template>
      </el-table-column>
      <el-table-column prop="pct_chg" width="100">
        <template #header>
          <span class="clickable" @click="togglePctSort">涨幅% <span v-if="sortKey==='pct_chg'">{{ sortOrder==='asc' ? '↑' : '↓' }}</span></span>
        </template>
        <template #default="{row}">
          <span v-if="Number.isFinite(computeRisePct(row))" :class="['pct-val', pctClass(computeRisePct(row))]">
            {{ formatPctWithSign(computeRisePct(row)) }}
          </span>
          <span v-else>—</span>
        </template>
      </el-table-column>
      <el-table-column prop="strategy" label="策略" width="120" />
      <el-table-column prop="verify_note" label="校验备注" />
      <el-table-column prop="status" label="状态" width="100">
        <template #default="{row}">
          <span class="status-val" :class="Number(row.status)===1 ? 'positive' : Number(row.status)===0 ? 'negative' : 'neutral'">
            {{ Number(row.status)===1 ? '已结算' : Number(row.status)===0 ? '未结算' : '—' }}
          </span>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="220">
        <template #default="{row}">
          <el-button size="small" @click="openEdit(row)">编辑</el-button>
          <el-button size="small" type="success" @click="openVerify(row)">验证</el-button>
          <el-button size="small" type="danger" @click="remove(row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      class="pager"
      :current-page="pagination.page"
      :page-size="pagination.pageSize"
      :total="pagination.total"
      layout="prev, pager, next"
      @current-change="pageChange"
    />

    <div class="batch-actions">
      <el-button type="danger" :disabled="!selection.length" @click="batchDelete">批量删除</el-button>
      <el-button type="success" :disabled="!selection.length" @click="openBatchVerify">批量验证</el-button>
      <span class="tips" v-if="selection.length">已选 {{ selection.length }} 条</span>
    </div>

    <el-dialog v-model="dialogVisible" title="编辑荐股记录" width="600px">
      <el-form :model="form" label-width="120px">
        <el-form-item label="ID">
          <el-input v-model="form.id" disabled />
        </el-form-item>
        <el-form-item label="日期(YYYYMMDD)">
          <el-input v-model="form.date" />
        </el-form-item>
        <el-form-item label="代码">
          <el-input v-model="form.code" />
        </el-form-item>
        <el-form-item label="名称">
          <el-input v-model="form.name" />
        </el-form-item>
        <el-form-item label="荐价">
          <el-input v-model="form.recommended_price" />
        </el-form-item>
        <el-form-item label="涨幅%">
          <el-input v-model="form.pct_chg" />
        </el-form-item>
        <el-form-item label="策略">
          <el-select v-model="form.strategy" clearable>
            <el-option v-for="opt in strategyOptions" :key="opt.value" :label="opt.label" :value="opt.value" />
          </el-select>
        </el-form-item>
        <el-form-item label="行业">
          <el-input v-model="form.industry" />
        </el-form-item>
        <el-form-item label="原因">
          <el-input v-model="form.reason" />
        </el-form-item>
        <el-form-item label="校验备注">
          <el-input v-model="form.verify_note" />
        </el-form-item>
        <el-form-item label="状态">
          <el-input v-model="form.status" />
        </el-form-item>
        <el-form-item label="批次ID">
          <el-input v-model="form.batch_id" />
        </el-form-item>
        <el-form-item label="荐股时间">
          <el-input v-model="form.recommended_at" />
        </el-form-item>
        <el-form-item label="校验时间">
          <el-input v-model="form.verified_at" />
        </el-form-item>
        <el-form-item>
          <el-button @click="dialogVisible = false">取消</el-button>
          <el-button type="primary" :loading="saving" @click="submit">保存</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog v-model="verifyVisible" title="单股验证" width="400px">
      <div style="padding: 10px 0;">
        <el-date-picker
          v-model="verifyDate"
          type="date"
          placeholder="选择验证日期"
          format="YYYY-MM-DD"
          value-format="YYYY-MM-DD"
          style="width: 220px"
        />
      </div>
      <template #footer>
        <el-button @click="verifyVisible=false">取消</el-button>
        <el-button type="primary" :loading="verifying" @click="doVerify">提交</el-button>
      </template>
    </el-dialog>
    <el-dialog v-model="batchVerifyVisible" title="批量验证" width="420px">
      <div style="padding: 10px 0;">
        <el-date-picker
          v-model="batchVerifyDate"
          type="date"
          placeholder="选择验证日期"
          format="YYYY-MM-DD"
          value-format="YYYY-MM-DD"
          style="width: 220px"
        />
        <div class="tips" style="margin-top:8px;">当前选中 {{ selection.length }} 条</div>
      </div>
      <template #footer>
        <el-button @click="batchVerifyVisible=false">取消</el-button>
        <el-button type="primary" :loading="batchVerifying" @click="submitBatchVerify">提交验证</el-button>
      </template>
    </el-dialog>
  </div>
  </template>

<script setup>
import { ref, onMounted, watch } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import request from '../../utils/request'
import store from '../../store'

const list = ref([])
const pagination = ref({ page: 1, pageSize: 100, total: 0 })
const filterDate = ref('')
const strategy = ref('')
const filterStatuses = ref([])
const sortKey = ref('')
const sortOrder = ref('desc')
const strategyOptions = [
  { label: '全部', value: '' },
  { label: '荐股', value: '尾盘荐股' },
  { label: '竞价', value: '集合竞价策略' },
  { label: '开盘', value: '开盘策略' },
  { label: '尾盘', value: '尾盘策略' },
  { label: '预测', value: '明日预测' },
]

const tableRef = ref()
const selection = ref([])

const loadList = async () => {
  const params = {
    page: pagination.value.page,
    page_size: pagination.value.pageSize
  }
  if (filterDate.value) params.date = filterDate.value
  if (strategy.value) params.strategy = strategy.value
  if (Array.isArray(filterStatuses.value) && filterStatuses.value.length) {
    params.status = filterStatuses.value.join(',')
  }
  if (sortKey.value) {
    params.sort = sortKey.value
    params.order = sortOrder.value || 'desc'
  }
  try {
    const data = await request.get('/v1/api/advice-stock-history', { params })
    const items = Array.isArray(data.items) ? data.items : []
    list.value = items
    pagination.value.total = Number(data.total || 0)
  } catch (e) {
    ElMessage.error(e.toString())
  }
}

const computeRisePct = (row) => {
  const status = Number(row?.status ?? NaN)
  if (status === 0) {
    const cp = Number(row?.current_price ?? NaN)
    const rp = Number(row?.recommended_price ?? NaN)
    if (!Number.isFinite(cp) || !Number.isFinite(rp) || rp === 0) return NaN
    return ((cp - rp) / rp) * 100
  }
  const pct = Number(row?.pct_chg ?? NaN)
  return Number.isFinite(pct) ? pct : NaN
}
const formatPctWithSign = (v) => {
  const n = Number(v)
  if (!Number.isFinite(n)) return ''
  const sign = n > 0 ? '+' : ''
  return `${sign}${n.toFixed(2)}%`
}
const pctClass = (v) => {
  const n = Number(v)
  if (!Number.isFinite(n) || n === 0) return 'neutral'
  return n > 0 ? 'positive' : 'negative'
}
const togglePctSort = () => {
  if (sortKey.value !== 'pct_chg') {
    sortKey.value = 'pct_chg'
    sortOrder.value = 'desc'
  } else {
    sortOrder.value = sortOrder.value === 'asc' ? 'desc' : 'asc'
  }
  loadList()
}

const pageChange = (p) => {
  pagination.value.page = p
  loadList()
}

const selChange = (val) => {
  selection.value = val
}

const batchVerifyVisible = ref(false)
const batchVerifyDate = ref('')
const batchVerifying = ref(false)
const openBatchVerify = () => {
  if (!selection.value.length) {
    ElMessage.warning('请先勾选记录')
    return
  }
  if (/^\d{8}$/.test(String(filterDate.value || ''))) {
    batchVerifyDate.value = `${String(filterDate.value).slice(0,4)}-${String(filterDate.value).slice(4,6)}-${String(filterDate.value).slice(6,8)}`
  } else {
    batchVerifyDate.value = ''
  }
  batchVerifyVisible.value = true
}
const submitBatchVerify = async () => {
  const ids = selection.value.map(it => it.id)
  if (!ids.length) {
    ElMessage.warning('请先勾选记录')
    return
  }
  if (!batchVerifyDate.value) {
    ElMessage.warning('请选择日期')
    return
  }
  try {
    batchVerifying.value = true
    const data = await request.post('/v1/api/advice/verify/update', { ids, date: batchVerifyDate.value })
    const items = Array.isArray(data?.items) ? data.items : []
    let updated = 0
    for (const it of items) {
      const id = Number(it?.id ?? NaN)
      if (!Number.isFinite(id)) continue
      const idx = list.value.findIndex(row => Number(row.id) === id)
      if (idx >= 0) {
        const next = { ...list.value[idx] }
        if (Number.isFinite(Number(it?.pct_chg ?? NaN))) next.pct_chg = Number(it.pct_chg)
        if (Number(it?.status ?? 0) === 1) next.status = 1
        list.value.splice(idx, 1, next)
        if (Number(it?.status ?? 0) === 1) updated++
      }
    }
    ElMessage.success(`批量验证完成，已更新 ${updated} 条`)
    batchVerifyVisible.value = false
    selection.value = []
  } catch (e) {
    ElMessage.error(e.toString())
  } finally {
    batchVerifying.value = false
  }
}

const dialogVisible = ref(false)
const form = ref({
  id: null,
  date: '',
  code: '',
  name: '',
  recommended_price: '',
  pct_chg: '',
  verify_note: '',
  status: '',
  reason: '',
  industry: '',
  strategy: '',
  batch_id: '',
  recommended_at: '',
  verified_at: ''
})
const saving = ref(false)

const openEdit = async (row) => {
  try {
    const detail = await request.get('/v1/api/advice/view', { params: { id: row.id } })
    Object.assign(form.value, detail || {}, { id: row.id })
    dialogVisible.value = true
  } catch (e) {
    ElMessage.error(e.toString())
  }
}

const verifyVisible = ref(false)
const verifyId = ref(null)
const verifyDate = ref('')
const verifying = ref(false)
const openVerify = (row) => {
  verifyId.value = row.id
  const d = String(row.date || '')
  if (/^\d{8}$/.test(d)) {
    verifyDate.value = `${d.slice(0,4)}-${d.slice(4,6)}-${d.slice(6,8)}`
  } else {
    verifyDate.value = ''
  }
  verifyVisible.value = true
}
const doVerify = async () => {
  if (!verifyId.value) {
    ElMessage.warning('缺少记录ID')
    return
  }
  if (!verifyDate.value) {
    ElMessage.warning('请选择日期')
    return
  }
  try {
    verifying.value = true
    const data = await request.post('/v1/api/advice/verify/update', { id: verifyId.value, date: verifyDate.value })
    ElMessage.success('验证成功')
    const idx = list.value.findIndex(it => it.id === verifyId.value)
    if (idx >= 0) {
      const next = { ...list.value[idx] }
      next.pct_chg = data?.pct_chg ?? next.pct_chg
      next.status = 1
      list.value.splice(idx, 1, next)
    } else {
      await loadList()
    }
    verifyVisible.value = false
  } catch (e) {
    ElMessage.error(e.toString())
  } finally {
    verifying.value = false
  }
}

const submit = async () => {
  try {
    saving.value = true
    const payload = { ...form.value }
    await request.post('/v1/api/advice/update', payload)
    ElMessage.success('更新成功')
    dialogVisible.value = false
    await loadList()
  } catch (e) {
    ElMessage.error(e.toString())
  } finally {
    saving.value = false
  }
}

const remove = async (row) => {
  try {
    await ElMessageBox.confirm(`确认删除ID=${row.id}的记录吗？`, '提示', { type: 'warning' })
    await request.post('/v1/api/advice/delete', null, { params: { id: row.id } })
    ElMessage.success('删除成功')
    await loadList()
  } catch (e) {
    if (e !== 'cancel') ElMessage.error(e.toString())
  }
}

const batchDelete = async () => {
  if (!selection.value.length) return
  const ids = selection.value.map(it => it.id)
  try {
    await ElMessageBox.confirm(`将删除选中 ${ids.length} 条记录，是否继续？`, '提示', { type: 'warning' })
    await request.post('/v1/api/advice/delete-multiple', { ids })
    ElMessage.success('批量删除成功')
    selection.value = []
    await loadList()
  } catch (e) {
    if (e !== 'cancel') ElMessage.error(e.toString())
  }
}

onMounted(() => {
  if (store.state.token) {
    loadList()
  } else {
    watch(() => store.state.token, (t) => t && loadList(), { immediate: true })
  }
})
</script>

<style scoped>
.advice-page .toolbar {
  margin-bottom: 15px;
  display: flex;
  gap: 10px;
}
.pct-val.positive { color: #d81e06; }
.pct-val.negative { color: #098551; }
.pct-val.neutral { color: #6b7280; }
.status-val.positive { color: #d81e06; }
.status-val.negative { color: #098551; }
.status-val.neutral { color: #6b7280; }
.clickable { cursor: pointer; user-select: none; }
.pager {
  margin-top: 15px;
  text-align: right;
}
.batch-actions {
  margin-top: 10px;
  display: flex;
  align-items: center;
  gap: 10px;
}
.tips {
  color: #909399;
  font-size: 12px;
}
</style>
